export default class {
  url = undefined;
  method = undefined;
  clearance = undefined;
  params = {};

  /**
   * @param {string} url
   * @param {string} method
   * @param {string|undefined} clearance
   */
  constructor(url, method = "get", clearance = undefined) {
    this.url = url;
    this.method = method;
    this.clearance = clearance;
  }

  /**
   * @param {Object.<string, string|string[]>} params
   * @returns {this}
   */
  setParams(params) {
    for (const key in params) {
      this.params[key] = params[key];
    }
    return this;
  }

  /**
   * @param {string[]} keys
   * @returns {this}
   */
  removeParams(keys) {
    for (const key of keys) {
      delete this.params[key];
    }
    return this;
  }

  submit() {
    const form = this.createForm();
    form.submit();
    setTimeout(function() {
      form.remove();
    });
  }

  /**
   * @returns {HTMLFormElement}
   */
  createForm() {
    const form = document.createElement("form");
    document.body.appendChild(form);
    form.setAttribute("method", this.method);
    form.setAttribute("action", this.url);
    form.setAttribute("target", "_blank");
    form.setAttribute("style", "display: none");

    if (this.clearance) {
      this.addFieldToForm(form, "clearance", this.clearance);
    }

    for (const [key, value] of Object.entries(this.params)) {
      if (Array.isArray(value)) {
        for (const arrayValue of value) {
          this.addFieldToForm(form, `${key}[]`, arrayValue);
        }
      } else {
        this.addFieldToForm(form, key, value);
      }
    }

    return form;
  }

  /**
   * @param {HTMLFormElement} form
   * @param {string} name
   * @param {string} value
   */
  addFieldToForm(form, name, value) {
    const field = document.createElement("input");
    field.setAttribute("name", name);
    field.setAttribute("value", value);
    form.appendChild(field);
  }
}
